import { useLocale } from '@spotify-internal/i18n-core';

export function useDateTimeFormatter(options: Intl.DateTimeFormatOptions = {}) {
  const locale = useLocale();
  return new Intl.DateTimeFormat(locale, options);
}
